import { getTimeString } from '../../../../backend/utils/getTimeString';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';
const Hours = ({ shiftParticipantId, hours, hoursStatus, t }) => {
    let hoursContent;
    if (hours) {
        hoursContent = t(`time`, { value: getTimeString(hours, true) });
    }
    else if (hoursStatus === 'deniedNoShow') {
        hoursContent = '-';
    }
    else {
        hoursContent = t('timeTracking.missingHoursTable');
    }
    return (React.createElement(Box, { display: 'flex', gap: 0.5, sx: { color: hoursStatus === 'deniedInaccurate' ? themeColors.decorative.orange : undefined } },
        React.createElement(Typography, { key: shiftParticipantId + '-hours', variant: 'body2', sx: {
                wordBreak: 'break-word',
            } }, hoursContent),
        hoursStatus === 'deniedInaccurate' && (React.createElement(Box, { display: 'flex', gap: 0.5 },
            React.createElement(Typography, { variant: 'body2' }, t('common.denied')),
            React.createElement(Tooltip, { title: t('timeTracking.deniedTooltipText') },
                React.createElement(InfoOutlinedIcon, { sx: {
                        color: themeColors.text.subtle,
                    } }))))));
};
export const VolunteeringHoursAndStatus = ({ participation, shiftParticipantId, hoursStatus, hours, t, }) => {
    const hourStatus = participation.columns.hoursStatus;
    switch (hourStatus) {
        case 'deniedNoShow':
            return (React.createElement(Box, { display: 'flex', sx: { gap: 1, alignItems: 'center', color: themeColors.text.subtle }, "data-test": 'denied-no-show-hours-status' },
                React.createElement(CancelIcon, null),
                React.createElement(Hours, { hoursStatus: hoursStatus, t: t, hours: hours, shiftParticipantId: shiftParticipantId }),
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'baseline', flexWrap: 'wrap' } },
                    React.createElement(Typography, { variant: 'body2' }, t('timeTracking.noShow')))));
        case 'deniedInaccurate':
        case 'addHours':
            return (React.createElement(Box, { display: 'flex', sx: { gap: 1, alignItems: 'center', color: themeColors.text.subtle }, "data-test": 'add-hours-status' },
                React.createElement(RemoveCircleIcon, { color: 'warning' }),
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'baseline', flexWrap: 'wrap' } },
                    React.createElement(Typography, { variant: 'body2' }, t('shifts.adminTimeTracking.noHours')))));
        case 'pending':
            return (React.createElement(Box, { display: 'flex', sx: { gap: 1, alignItems: 'center', color: themeColors.text.subtle }, "data-test": 'pending-hours-status' },
                React.createElement(TimelapseIcon, { color: 'warning' }),
                React.createElement(Hours, { hoursStatus: hoursStatus, t: t, hours: hours, shiftParticipantId: shiftParticipantId }),
                React.createElement(Typography, { variant: 'body2' }, t('missions.missionDetails.pendingRequest'))));
        case 'approved':
            return (React.createElement(Box, { display: 'flex', sx: { gap: 1, alignItems: 'center' }, "data-test": 'approved-hours-status' },
                React.createElement(CheckCircleIcon, { color: 'success' }),
                React.createElement(Hours, { hoursStatus: hoursStatus, t: t, hours: hours, shiftParticipantId: shiftParticipantId }),
                React.createElement(Typography, { variant: 'body2' }, t('timeTracking.approved'))));
        default:
            return React.createElement(React.Fragment, null, hourStatus);
    }
};
